import { render, staticRenderFns } from "./LianLianCard.vue?vue&type=template&id=425dbf24&scoped=true&"
import script from "./LianLianCard.vue?vue&type=script&lang=js&"
export * from "./LianLianCard.vue?vue&type=script&lang=js&"
import style0 from "./LianLianCard.vue?vue&type=style&index=0&id=425dbf24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425dbf24",
  null
  
)

export default component.exports